import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Button, Grid, Card, CardContent } from "@mui/material";
import { styled } from "@mui/system";
import ScrollReveal from "scrollreveal"; // ✅ Importamos ScrollReveal
import AnimatedHeader from "../components/AnimatedHeader.js";
import crmCap2 from "../assets/crmCap3.png";
import heroImg from "../assets/hero-image.webp";

// ✅ Sección Hero con clase CSS específica
const HeroSection = styled("div")({
  textAlign: "center",
  padding: "50px 20px",
  background: "#f5f5f5",
  boxShadow: "0 0 10px #0000001a",
}).withComponent("div");

// ✅ Tarjetas con clase específica para aplicar animaciones
const FeatureCard = styled(Card)({
  display: "grid",
  textAlign: "center",
  alignItems: "center",
  padding: "20px",
  minHeight: "200px",
  boxShadow: "0 2px 2px #ffffff40, inset 0 1px 3px #0000004d",
}).withComponent("div");

const LandingPageProf = () => {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: "top", // Dirección de aparición
      distance: "80px", // Distancia del efecto
      duration: 2000, // Duración de la animación
      reset: true, // Hace que el efecto se repita al hacer scroll
    });

    // Aplicar efecto a cada elemento con su respectiva clase
    sr.reveal(".home-title", {});
    sr.reveal(".button", { delay: 200 });
    sr.reveal(".home-img", { delay: 400 });
    sr.reveal(".home-social", { delay: 400 });

    sr.reveal(".about-img", {});
    sr.reveal(".about-subtitle", { delay: 200 });
    sr.reveal(".about-text", { delay: 400 });

    sr.reveal(".skills-subtitle", { delay: 100 });
    sr.reveal(".skills-text", { delay: 150 });
    sr.reveal(".skills-data", { interval: 200 });
    sr.reveal(".skills-img", { delay: 400 });

    sr.reveal(".work-img", { interval: 200 });

    sr.reveal(".contact-input", { interval: 200 });
  }, []);

  return (
    
    <main>

      <header class="header-lp">
        <AnimatedHeader />
      </header>
    <div className="l-main"> 
    {/* Sección de Inicio */}
      <section className="bd-grid" id="home">
        <div className="home-data-lp">
          <h1 className="home-title">
          <span className="home-title-color"> Potenciá </span> tu negocio, <br />
          atraé más clientes <br />y<span className="home-title-color"> aumentá</span> tus ingresos con <br /> <span className="home-title-color">Apimys.</span>
          </h1>
        </div>

      </section>

      {/* Sección About */}
      <section className="about section" id="about">
        <h2 className="section-title">Oficina Virtual</h2>
        <div className="about-container bd-grid">
          <div className="about-img">
            <img src={heroImg} alt="oficina profesional" />
          </div>
          <div>
            <h2 className="about-subtitle">Somos Apimys</h2>
            <p className="about-text">
            Crea tu oficina profesional en minutos y hacé crecer tu negocio            </p>
          </div>
        </div>
      </section>

      {/* Sección Skills */}
      <section className="skills section" id="skills">
        <h2 className="section-title">Obtené</h2>
        <div className="skills-container bd-grid">
          <div className="conteinerTextoSill">
            <p className="skills-text">
              Estás son algunas de las cosas que hacemos por vos.
            </p>
            <div class="skills-data">
                <div class="skills-names">
                    <span class="skills-name">🌟 Clientes nuevos sin esfuerzo</span>
                </div>
                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <span class="skills-name">📈 Automatización con IA para mejorar ventas.</span>
                </div>
                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <i class='bx bxl-javascript skills-icon' ></i>
                    <span class="skills-name">🎯 Herramientas de fidelización para retener clientes.</span>
                </div>

                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>

            <div class="skills-data">
                <div class="skills-names">
                    <i class='bx bxs-paint skills-icon' ></i>
                    <span class="skills-name">💡 Estrategias de crecimiento que realmente funcionan.</span>
                </div>

                <div>
                    <span class="skills-percentage"></span>
                </div>
                <div class="skills-bar"></div>
            </div>
          </div>
          <div className="conteinerImgSkill">
            <img src={crmCap2} alt="crm profesional" className="skills-img" />
          </div>
        </div>
        <div className="btnARegistro">
        <Link to="/Register"><Button variant="contained" sx={{ backgroundColor: "#007bff", "&:hover": { backgroundColor: "#0056b3" } }} size="large">
          Quiero más clientes
        </Button></Link>
        </div>
      </section>

      {/* Sección Work */}
      <section className="work section" id="work">
        <h2 className="section-title">Fidelización.</h2>
        <div className="work-container bd-grid">
            <div className="work-img">
              <h3>Multiplicá tu facturación sin depender de recomendaciones al azar.</h3>
            </div>   
            <div className="work-img">
              <h3>Nosotros hacemos la publicidad por vos. Más clientes, menos preocupaciones.</h3>
            </div>   
            <div className="work-img">
              <h3>Automatizá el seguimiento de tus clientes y aumentá tu retención.</h3>
            </div>   
        </div>
        <h3>Apimys te ayuda a conseguir más clientes y a fidelizarlos con estrategias probadas.</h3>
      </section>

      {/* Sección Contact */}
      <section className="contact section" id="contact">
        <h2 className="section-title">Registrate ahora</h2>
        <div className="contact-container">
        <p className="skills-text">Los primeros 100 profesionales tienen 3 meses GRATIS, luego solo $3.500/mes.</p>
        <Link to="/Register"><Button variant="contained" sx={{ backgroundColor: "#007bff", "&:hover": { backgroundColor: "#0056b3" } }} size="large">
          ¡Únete Ahora!
        </Button></Link>
        </div>
      </section>
      </div>
    </main>
  );
};

export default LandingPageProf;
